import { Button, ButtonProps } from "@pallet-hq/hegel"
import mixpanel from "mixpanel-browser"
import { BUTTON_TYPES, TRACK_EVENTS } from "constants/events"
import config from "config"
import { ContingencyCta_applylist } from "__generated__/ContingencyCta_applylist"

type ContingencySalesButtonProps = {
    applylist: ContingencyCta_applylist
} & Omit<ButtonProps, "children">

export const ContingencySalesButton = ({
    applylist,
    ...props
}: ContingencySalesButtonProps) => {
    const handleClick = () => {
        mixpanel.track(TRACK_EVENTS.COLLECTIVE_TIER_SELECTED, {
            type: BUTTON_TYPES.SUBSCRIBE,
            applylist_slug: applylist.slug,
            contingency: true,
        })
        return window.open(
            config.CALENDLY_CONTINGENCY_URL +
                "?q1=" +
                encodeURIComponent(applylist.name)
        )
    }

    return (
        <Button
            variant={"secondary"}
            size="small"
            mt="small"
            width="100%"
            {...props}
            onClick={handleClick}
        >
            Talk to us
        </Button>
    )
}
